export const ACCOUNT_SETUP_TEXT = 'Account Setup'
export const ACCOUNT_SETUP_INCOMPLETE_TEXT = 'Account Setup Incomplete'
export const ACCOUNT_SETUP_SUBTEXT = `Please fill in the below details so that we can setup an account for your organisation in our system and 
give you access to the Do-It-Yourself portal for listing your event.`

export const GENERAL_INFO_PATH = '/create-account/general-information'
export const UPLOAD_DOCUMENTS_PATH = '/create-account/upload-documents'
export const SIGN_AGREEMENT_PATH = '/create-account/sign-agreement'
export const ACKNOWLEDGEMENT_PATH = '/create-account/acknowledgement'

export const progressSteps = [
	'general-information',
	'upload-documents',
	'sign-agreement',
]

export const sections = [
	'General Information',
	'Upload documents',
	'Sign agreement',
]

export const sectionTitles = {
	GENERAL_INFO_PATH: sections[0],
	UPLOAD_DOCUMENTS_PATH: sections[1],
	SIGN_AGREEMENT_PATH: sections[2],
}

export const uploadDocumentsCriteriaPoints = {
	subTitle: 'Please make sure that:',
	points: [
		'Upload a clear image in .jpg or .pdf format only.',
		'File size should not be greater than 2mb.',
	],
}

export const documentTitles = {
	panCardTitle: 'Upload PAN card',
	cancelledChequeTitle: 'Upload Cancelled Cheque',
	gstCertificatesTitle: 'Upload GST Certificate',
}

export const sampleImages = {
	panCard: {
		title: 'PAN card example',
		url: 'https://in.bmscdn.com/webin/events/diy/sample-pan-card.png',
	},
	cancelledCheque: {
		title: 'Cancelled Cheque example',
		url: 'https://in.bmscdn.com/webin/events/diy/sample-cancelled-cheque.png',
	},
	gstCertificates: {
		title: 'GST Certificate example',
		url: 'https://in.bmscdn.com/webin/events/diy/sample-gst-certificate.png',
	},
}

export const viewExampleCtaText = 'View example'

export const RadioButtonData = [
	{
		label: 'Yes',
		id: 'true',
	},
	{
		label: 'No',
		id: 'false',
	},
]

export const signDigitallyDesription =
	'You will be redirected to an external website to digitally sign the agreement.'

export const downloadAgreementDecription =
	'Upload signed agreement, click on ‘Download agreement’ to download the agreement. Upload a .pdf format only. File size should not be greater than 2mb.'

export const emailInfo = {
	description: 'Incase of any query, please write to',
	emailId: 'bd@bookmyshow.com',
}

export const acknowledgement = {
	title: 'Thank you for your details!',
	description:
		'We have received your application. Your application is currently getting reviewed by our team. We will get back to you in 2-3 business days',
}

export const gstNote =
	'Note: You can add multiple GSTIN numbers and certificates for different states later through profile section of DIY.'

export const addGST = '+Add another GSTIN number'

export const addressToolTipDescription =
	'Organisation/Individual address should be same as mentioned in PAN/GST'
export const nameToolTipDescription =
	'Organisation/Individual name should be same as mentioned in PAN/GST'

export const declarationContent =
	'<div><p>I/We, Organizer, do confirm and acknowledge that I am/We are a supplier providing services through an e­ commerce platform as per Section 24(1X) of the Central Goods and Services Tax under the prevalent GST regime ("GST Laws") and confirm that I/We are not registered under the GST Act, since our annual turnover is below the threshold limit of Rs. 20 Lakhs (supplier supply only services).</p><p>I/We confirm that any applicable taxes collected on the Tickets booked through Bigtree Entertainment Pvt. Ltd.’s platform i.e. www.bookmyshow.com and/or its mobile application and/or other sales channels is our liability and the same shall be duly discharged by us.</p><p>I/We acknowledge that information furnished above are true to the best of my/our knowledge and that we shall be bound by the acts of duly constituted attorney. In case any of the above information is found to be incorrect at a later date, my membership with your platform shall stand cancelled and any payment or unprocessed bill shall be withheld by you on the basis of the statements given herein above, I/We request you to permit and allow our event to be listed on your platform. I/We shall indemnify and hold harmless you and your officers, representatives, affiliates, successors and assigns, against all costs, penalties, damages, or losses or any other charges, penalties, or liabilities incurred in relation to any claim raised pursuant to the following:</p><ol><li>Breach, violation or non-compliance of any of the provisions contained in this declaration.</li><li>Any act of omission or commission pursuant to which any of the representations given become untrue.</li><li>Violation of any applicable law including GST laws.</li><li>Non-compliance with GST laws.</li><li>Any investigations, inquiries, summons or inspections conducted by any authority.</li></ol><p>I/We also undertake the responsibility to inform all subsequent changes in the constitution or working of my/our business entity having membership with your platform, affecting the accuracy of the answers given will be promptly communicated to you.</p></div>'

export const genericErrorMesssage =
	'Something is not right here. Please try after some time.'

export const errorMessageObj = {
	nameError: 'Please enter a valid organisation name',
	panNoError: 'Please enter a valid PAN card number',
	addressError: 'Please enter a valid address',
	fullNameError: 'Please enter a valid full name',
	emailError: 'Please enter a valid email',
	accountNameError: 'Please enter a valid beneficiary name',
	bankNameError: 'Please enter a valid bank Name',
	accountNumberError: 'Please enter a valid account number',
	ifscError: 'Please enter a valid bank IFSC',
	gstNoError: 'Please enter a valid GSTIN Number',
	gstStateError: 'Please enter a valid GSTIN State',
	duplicateGSTError: 'Duplicate GST No',
}

export const accountTypeList = [
	{
		value: 'current',
		label: 'Current account',
	},
	{
		value: 'savings',
		label: 'Savings account',
	},
	{
		value: 'salary',
		label: 'Salary account',
	},
	{
		value: 'nri',
		label: 'NRI account',
	},
]

export const IN_PROGRESS = 'INPROGRESS'
export const PENDING = 'PENDING'
export const APPROVED = 'APPROVED'
export const REJECTED = 'REJECTED'

export const ERRORCODES = ['ERROR.GETTING.DATA', 'INVALID TOKEN']

export const eventActionNames = {
	GENERAL_INFO_PATH: 'general_info',
	UPLOAD_DOCUMENTS_PATH: 'upload_doc',
	SIGN_AGREEMENT_PATH: 'sign_agreement',
}
